/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ITextStyle, TEXT_GRADIENT, TextStyle } from 'pixi.js-legacy';

export interface FancyTextOptions {
	align?: 'left' | 'center' | 'right' | 'justify';
	breakWords?: boolean;
	debugMode?: boolean;
	dropShadow?: boolean;
	dropShadowAlpha?: number;
	dropShadowAngle?: number;
	dropShadowBlur?: number;
	dropShadowColor?: string | number;
	dropShadowDistance?: number;
	fill?: string | string[] | number | number[] | CanvasGradient | CanvasPattern;
	fillGradientType?: TEXT_GRADIENT;
	fillGradientStops?: number[];
	fontFamily?: string | string[];
	fontSize?: number | string;
	fontStyle?: 'normal' | 'italic' | 'oblique';
	fontVariant?: 'normal' | 'small-caps';
	fontWeight?:
		| 'normal'
		| 'bold'
		| 'bolder'
		| 'lighter'
		| '100'
		| '200'
		| '300'
		| '400'
		| '500'
		| '600'
		| '700'
		| '800'
		| '900';
	leading?: number;
	letterSpacing?: number;
	lineHeight?: number;
	lineJoin?: 'miter' | 'round' | 'bevel';
	miterLimit?: number;
	padding?: number;
	resolution?: number;
	stroke?: string | number;
	strokeThickness?: number;
	trim?: boolean;
	textBaseline?: 'alphabetic' | 'top' | 'hanging' | 'middle' | 'ideographic' | 'bottom';
	whiteSpace?: 'normal' | 'pre' | 'pre-line';
	wordWrap?: boolean;
	wordWrapWidth?: number;
}

export class FancyTextStyle extends TextStyle {
	public debugMode: boolean = false;
	public resolution = 1;
	constructor(options?: FancyTextOptions) {
		super(options);
		this.debugMode = options.debugMode;
		this.resolution = options.resolution;
	}
}
